
import { Component, Vue, Inject, Prop, Watch, Ref } from "vue-property-decorator";
import api from "@/api";
import {
  UserCardDto,
  UserCardDeductionInput,
  UserDiffCardDto, UserDto
} from "@/api/appService";
import { ElForm } from 'element-ui/types/form';

@Component
export default class UseUserCard extends Vue {
  @Ref() readonly dataForm!: ElForm;
  input!: UserCardDto;
  show: boolean = false;
  userId:number = 0;

  private userCards: UserCardDto[] = [];
  private selectUserCard: UserCardDto = { id: 0 };
  private form: UserCardDeductionInput = {};
  private diffCardBalance: number = 0;
  private babyName:string = '';


  @Watch('userId')
  onUserIdChange(value:number){
    if(value){
      api.user.get({id:value}).then(res=>{
        this.babyName = (`${res.babyDetail?.realname}/${res.babyDetail?.nickname}`);
      })
    }
  }


  @Watch("selectUserCard")
  async onSelectUserCardChange(value: UserCardDto) {
    this.form.userCardId = value.id;
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    console.log(value);
    if (value) {
      await api.userCard.getUserCards({ id: this.input!.id,userId:this.input!.creatorUserId }).then(res => {
        this.userCards = res;
        this.selectUserCard = this.selectUserCard = Object.assign(
          {
            balance:0,
            babyName:''
          },
          (this.userCards && this.userCards.length?this.userCards[0]:{}),
        );
      });
      await api.userCard
        .getUserDiffCardBalance({ userId: this.input!.creatorUserId })
        .then(res => {
          this.diffCardBalance = res;
        });
    } else {
      this.form = {};
      this.selectUserCard = { id: 0 };
    }

     this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  created() {}

  cancel() {
    this.show = false;
  }

  save() {
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.form.userId = this.userId;
        api.userCard
          .deduction({
            body: this.form
          })
          .then(res => {
            this.$message.success("扣费成功");
            this.show = false;
            this.$emit("onSave");
          });
      }
    });
  }

  async onChange(e: number) {
    console.log(this.userCards.filter(x => x.id == e)[0]);
    this.selectUserCard = Object.assign(
      {},
      this.userCards.filter(x => x.id == e)[0]
    );
  }

  roleRule = {
    period: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    ammount: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    userCardId: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
